import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

import { reducers } from './reducers';
import { IRootState } from './type';

const initialState: IRootState = {
  staff: [],
  isDisplaySuccessAnimation: false,
};

export const slice = createSlice({
  name: STORE_SLICES.POS,
  initialState,
  reducers,
});

const posActions = slice.actions;

const posPersistConfig = {
  key: PERSIST_KEYS.POS,
  storage,
  whitelist: ['staff'],
};

export {
  posActions,
};

export default persistReducer(posPersistConfig, slice.reducer);
